import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AmericanFootBallIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.23541 4.23541C0.596936 7.87388 0.659046 13.8351 1.41196 14.588C2.16488 15.341 8.12612 15.4031 11.7646 11.7646C15.4031 8.12612 15.341 2.16488 14.588 1.41196C13.8351 0.659046 7.87388 0.596936 4.23541 4.23541ZM11.3536 4.64645C11.1583 4.45118 10.8417 4.45118 10.6464 4.64645L10.0703 5.22254L9.27746 4.42965C9.0822 4.23439 8.76561 4.23439 8.57035 4.42965L8.42893 4.57107C8.23367 4.76633 8.23367 5.08292 8.42893 5.27818L9.22182 6.07107L8.07027 7.22262L7.27738 6.42973C7.08212 6.23446 6.76554 6.23446 6.57027 6.42973L6.42885 6.57115C6.23359 6.76641 6.23359 7.08299 6.42885 7.27825L7.22175 8.07115L6.07027 9.22262L5.27738 8.42973C5.08212 8.23446 4.76554 8.23446 4.57027 8.42973L4.42885 8.57115C4.23359 8.76641 4.23359 9.08299 4.42885 9.27825L5.22175 10.0711L4.64645 10.6464C4.45118 10.8417 4.45118 11.1583 4.64645 11.3536C4.84171 11.5488 5.15829 11.5488 5.35355 11.3536L5.92885 10.7783L6.72175 11.5711C6.91701 11.7664 7.23359 11.7664 7.42885 11.5711L7.57027 11.4297C7.76554 11.2345 7.76554 10.9179 7.57027 10.7226L6.77738 9.92973L7.92885 8.77825L8.72175 9.57115C8.91701 9.76641 9.23359 9.76641 9.42885 9.57115L9.57027 9.42973C9.76554 9.23446 9.76554 8.91788 9.57027 8.72262L8.77738 7.92973L9.92893 6.77818L10.7218 7.57107C10.9171 7.76633 11.2337 7.76633 11.4289 7.57107L11.5703 7.42965C11.7656 7.23439 11.7656 6.91781 11.5703 6.72254L10.7775 5.92965L11.3536 5.35355C11.5488 5.15829 11.5488 4.84171 11.3536 4.64645Z"
			></path>
		</svg>
	),
)
